/**
 * Hook personalizado para llamadas telefónicas
 */

import { useCallback } from 'react';
import { COMPANY_INFO } from '../constants';

/**
 * Hook para manejar llamadas telefónicas
 * @returns {Object} - Funciones para realizar llamadas
 */
export const usePhone = () => {
  const phoneNumber = COMPANY_INFO.phone;

  /**
   * Inicia una llamada telefónica
   * @param {string} number - Número de teléfono (opcional, usa el de la empresa por defecto)
   */
  const makeCall = useCallback((number = phoneNumber) => {
    window.open(`tel:${number}`, '_self');
  }, [phoneNumber]);

  /**
   * Llama al número principal de la empresa
   */
  const callCompany = useCallback(() => {
    makeCall(phoneNumber);
  }, [makeCall, phoneNumber]);

  return {
    makeCall,
    callCompany,
    phoneNumber,
    phoneFormatted: COMPANY_INFO.phoneFormatted
  };
};

export default usePhone;
